import React, { useState } from "react";
import "./settings.scss";

const SettingsPage = () => {
  const [websiteOnline, setWebsiteOnline] = useState(true);
  const [whatsapp, setWhatsapp] = useState("+6019-8918933");
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState("");

  const saveSettings = (event) => {
    event.preventDefault();
    if (!/^\+?[0-9\s-]{8,20}$/.test(whatsapp.trim())) {
      setError("Enter a valid WhatsApp number, including the country code.");
      setSaved(false);
      return;
    }
    setError("");
    setSaved(true);
  };

  return (
    <div className="settings-page">
      {saved && <div className="settings-page__notice">✓ Website settings saved.<button onClick={() => setSaved(false)}>×</button></div>}
      <section className="settings-page__heading">
        <h2>Website settings</h2>
        <p>Configure storefront availability and the WhatsApp enquiry contact.</p>
      </section>

      <form className="settings-page__form" onSubmit={saveSettings}>
        <section className="settings-page__card">
          <div className="settings-page__card-head">
            <div><p>WEBSITE STATUS</p><h3>Storefront availability</h3></div>
            <span className={`settings-page__badge ${websiteOnline ? "settings-page__badge--online" : "settings-page__badge--offline"}`}>{websiteOnline ? "Online" : "Offline"}</span>
          </div>
          <div className="settings-page__setting">
            <div><strong>Website is available to visitors</strong><small>When offline, visitors will see a temporary maintenance page.</small></div>
            <button type="button" className={`settings-page__switch ${websiteOnline ? "settings-page__switch--on" : ""}`} onClick={() => { setWebsiteOnline((value) => !value); setSaved(false); }} aria-label="Toggle website status"><i /></button>
          </div>
          {!websiteOnline && <div className="settings-page__warning">The public website will be unavailable after these settings are saved. The admin portal will remain accessible.</div>}
        </section>

        <section className="settings-page__card">
          <div className="settings-page__card-head"><div><p>WHATSAPP</p><h3>Enquiry contact</h3></div></div>
          <label className="settings-page__field">
            <span>WhatsApp number</span>
            <div><b>WA</b><input value={whatsapp} onChange={(event) => { setWhatsapp(event.target.value); setError(""); setSaved(false); }} placeholder="+6012-3456789" /></div>
            <small>Use the international country code. This number is used by all WhatsApp enquiry buttons on the website.</small>
          </label>
          {error && <div className="settings-page__error">{error}</div>}
        </section>

        <div className="settings-page__actions"><button className="ui-button ui-button--primary" type="submit">Save settings</button></div>
      </form>
    </div>
  );
};

export default SettingsPage;
